<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'create-sub-category'"
    @hidden="$emit('onCloseModal')"
  >
    <b-form
      id="privilege-sub-category-modal"
      @submit.prevent="onSubmitCategory"
    >
      <div class="pt-3 px-2 category-modal">
        <div class="row border-category-modal">
          <div class="col-12">
            <div class="row">
              <div class="col-md-6">
                <div>
                  <span>{{ 'Status' }} </span>
                  <b-form-checkbox
                    v-model="categoryModal.status"
                    class="custom-control-success custom-toggle"
                    name="check-button"
                    switch
                  >
                    <span class="switch-icon-left toggle-text">{{
                      'Active'
                    }}</span>
                    <span class="switch-icon-right toggle-text">{{
                      'Inactive'
                    }}</span>
                  </b-form-checkbox>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <b-form-group
                      :label="'Reference'"
                      label-for="'Reference"
                      class=""
                    >
                      <b-form-input
                        id="Reference"
                        v-model="categoryModal.Reference"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div />
                <b-form-group
                  :label="'Name (En)'"
                  label-for="'name-en"
                  class="required"
                >
                  <b-form-input
                    id="name-en"
                    v-model="categoryModal.nameEn"
                    required
                  />
                </b-form-group>
                <b-form-group
                  :label="'Name (Th)'"
                  label-for="'name-th"
                  class="required"
                >
                  <b-form-input
                    id="name-en"
                    v-model="categoryModal.nameTh"
                    required
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <div>
          <span class="information-header p-0">Image or Banner</span>
        </div>
        <div class="row border-category-modal">
          <div class="col-12">
            <div class="row mt-2">
              <div class="col-md-6 mb-2">
                <label for="icon-image">
                  <span class="information-detail">{{ 'Icon/Image' }}</span>
                </label>
                <image-uploader
                  :image-url="categoryModal.image.url"
                  @onUpload="onUploadImage"
                />
              </div>
              <div class="col-md-6 mb-2">
                <label for="sub-icon-image">
                  <span class="information-detail">{{ 'Sub Icon/Image' }}</span>
                </label>
                <image-uploader
                  :image-url="categoryModal.imageSub.url"
                  @onUpload="onUploadImageSub"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <span class="information-header p-0">Tag</span>
        </div>
        <div class="row pb-4">
          <div class="col-12">
            <div class="row">
              <div class="col col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <v-select
                      id="modal-sup-category-tier-option"
                      v-model="categoryModal.tag"
                      multiple
                      :options="optionData.tagList.payload"
                      class="tag-dropdown"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="privilege-btn-wrp mt-2 mb-2">
          <div class="d-flex justify-content-center">
            <cancel-button
              class="mr-1"
              @click.native="$emit('onCloseModal')"
            />
            <save-button
              type="submit"
              class="ml-1"
            />
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import useCreateSubCategory from '../hooks/useCreateSubCategoryModal'

export default {
  props: {
    CategoryId: { type: Number, default: 0 },
    CategorySubId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      categoryModal,
      optionData,
      onUploadImage,
      onUploadImageSub,
      onSubmitCategory,
    } = useCreateSubCategory(props)
    return {
      categoryModal,
      optionData,
      onUploadImage,
      onUploadImageSub,
      onSubmitCategory,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/privilege/create-sub-category-modal.css';
@import '~@/assets/css/override-styles/tag-dropdown.css';
</style>
